module.exports = __webpack_public_path__ + "img/Dantam Fashion 03.bf45c8d3.jpg";